<template>
  <div>
    <v-container fluid v-if="LoadingProducts" class="pa-0 product-list-spinner">
      <v-layout class="fill-height" column pr-4>
        <v-flex>
          <v-layout fill-height align-center justify-center>
            <v-progress-circular :size="35" :width="3" color="accent" indeterminate></v-progress-circular>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-tabs v-else v-model="productTab">
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab class="py-2">
        <v-avatar size="32" color="green" class="mr-2">
          <span class="white--text">{{ availableGreenProducts.length }}</span>
        </v-avatar>
      </v-tab>
      <v-tab>
        <v-avatar size="32" color="orange" class="mr-2">
          <span class="white--text">{{ availableAmberProducts.length }}</span>
        </v-avatar>
        Amber
      </v-tab>
      <v-tab v-if="!UserHasRole('Broker')">
        <v-avatar size="32" color="red" class="mr-2">
          <span class="white--text">{{ availableRedProducts.length }}</span>
        </v-avatar>
        Red
      </v-tab>
      <v-tab v-if="UserHasRole('Platform')">
        <v-avatar size="32" color="grey" class="mr-2">
          <v-icon small>fad fa-user-secret</v-icon>
        </v-avatar>
        Invisible Funders
      </v-tab>
      <v-tab-item class="product-list" v-if="showIndividualProducts">
        <v-expansion-panels tile>
          <product-list-item
            v-for="product in availableGreenProducts"
            :product="product"
            :key="product.id"
            :color="product.colour"
            :enquiries="SelectedCustomer.enquiries"
          />
        </v-expansion-panels>
      </v-tab-item>

      <v-tab-item class="product-list" v-if="showIndividualProducts">
        <v-expansion-panels tile>
          <product-list-item
            v-for="product in availableAmberProducts"
            :product="product"
            :key="product.id"
            :color="product.colour"
            :enquiries="SelectedCustomer.enquiries"
          />
        </v-expansion-panels>
      </v-tab-item>

      <v-tab-item class="product-list" v-if="!UserHasRole('Broker')">
        <v-expansion-panels tile>
          <product-list-item
            v-for="product in availableRedProducts"
            :product="product"
            :key="product.id"
            :color="product.colour"
            :enquiries="SelectedCustomer.enquiries"
          />
        </v-expansion-panels>
      </v-tab-item>

      <v-tab-item class="product-list" v-if="UserHasRole('Platform')">
        <v-expansion-panels tile>
          <product-list-item
            v-for="product in HiddenProducts"
            :product="product"
            :key="product.id"
            :color="product.colour"
            :enquiries="SelectedCustomer.enquiries"
          />
        </v-expansion-panels>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ProductListItem from '@/components/Platform/Customers/OverviewDrawer/Products/ProductListItem';

export default {
  name: 'product-list',
  components: { ProductListItem },
  props: ['accountId', 'exclusions', 'isBankReferral', 'journeyId'],
  data: () => ({
    productTab: 0
  }),
  computed: {
    ...mapGetters([
      'RedProducts',
      'AmberProducts',
      'GreenProducts',
      'HiddenProducts',
      'SelectedCustomer',
      'LoadingProducts',
      'UserHasRole'
    ]),
    availableGreenProducts: function() {
      return this.userCanView ? this.applyProductFilters(this.GreenProducts) : [];
    },
    availableAmberProducts: function() {
      return this.userCanView ? this.applyProductFilters(this.AmberProducts) : [];
    },
    availableRedProducts: function() {
      return this.UserHasRole('Platform') || this.UserHasRole('Property Broker')
        ? this.applyProductFilters(this.RedProducts)
        : [];
    },
    showIndividualProducts() {
      return !(this.UserHasRole('Broker') && this.SelectedCustomer.question_completion_percentage !== 100);
    },
    userCanView() {
      return (
        this.UserHasRole('Platform') ||
        (this.SelectedCustomer.question_completion_percentage > 95 &&
          (this.UserHasRole('Broker') || this.UserHasRole('Property Broker')))
      );
    }
  },
  methods: {
    applyProductFilters: function(productsToFilter) {
      let products = _.orderBy(productsToFilter, ['score'], ['desc']);

      if (this.isBankReferral === true) {
        products = _.filter(products, product => !_.includes('No DB referrals', product.terms));
      } else {
        products = _.filter(products, product => !_.includes('Standard Terms - DB referrals only', product.terms));
      }

      const referrerAccountId = _.get(this.SelectedCustomer, 'referrer.account_id', null);

      return _.filter(
        products,
        product =>
          !_.includes(this.exclusions, product.business_id) &&
          product.provider_account_id !== this.accountId &&
          product.provider_account_id !== referrerAccountId &&
          product.journey_id === this.journeyId
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list,
.product-list-spinner {
  height: calc(100vh - 325px);
  max-height: calc(100vh - 325px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.product-list-spinner {
  height: calc(100vh - 325px + 48px);
  max-height: calc(100vh - 325px + 48px);
}
</style>
